import { FormControl, InputLabel, Select } from '@mui/material'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import ListItemText from '@mui/material/ListItemText'
import MenuItem from '@mui/material/MenuItem'
import OutlinedInput from '@mui/material/OutlinedInput'

import CustomButton from 'Components/CustomButton/CustomButton'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { currentDate } from 'utils/helpers'
import { Input } from '../../../Components/Input'
import { makeGetRequest } from 'utils/api'
import { makePostRequest } from 'utils/api'
import SnackBar2 from '../../../Components/SnackBar2'
import { toast } from 'react-toastify'
// import DirectionSnackbar from '../../../Components/Snackbar'

const ITEM_HEIGHT = 50
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 350,
    },
  },
}
export default function CreateCategory({ fetchCategorys }) {
  const [open, setOpen] = useState(false)
  const [alertOpen, setAlertOpen] = useState(false)
  const [contacts, SetContacts] = useState([])
  const [personContact, setPersonContact] = useState([])
  const handleChange = (event) => {
    const {
      target: { value },
    } = event
    setPersonContact(typeof value === 'string' ? value.split(',') : value)
  }
  const handleClickOpen = async () => {
    setOpen(true)
    const contacts = await makeGetRequest('/api/Social/get-contact-for-categories', {}, true)
    SetContacts(contacts.data)
  }

  const handleClose = () => {
    setOpen(false)
  }
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      Date: currentDate(),
    },
  })
  const onSubmit = (data) => {
    let url = '/api/Social/create-category/'

    let formData = new FormData()

    if (data.Categorie !== null) {
      formData.append('Categorie', data.Categorie)
    }
    if (data.SousCategorie !== null) {
      formData.append('SousCategorie', data.SousCategorie)
    }
    formData.append('Contacts', personContact)
    for (let [key, value] of formData) {
    }
    let response = makePostRequest(url, formData, {}, {}, true)
      .then((res) => {
        fetchCategorys()

        res.status === 200 &&
          toast(`${res.data}`, {
            position: 'bottom-left',
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            theme: 'dark',
            pauseOnFocusLoss: false,
          })
      })
      .catch((err) => {
        console.log(err.response.data)
      })
    if (response.status === 201) {
      handleClose()
    }
    fetchCategorys()
    setOpen(false)
  }
  return (
    <>
      <CustomButton onClick={handleClickOpen}>créer</CustomButton>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>Gérer categories</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                size: 'small',
                type: 'text',
                required: true,
              }}
              name="Categorie"
              label="Categorie"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
              }}
              name="SousCategorie"
              label="SousCategorie"
            />
            <FormControl style={{ m: 1, width: '386px' }}>
              <InputLabel>List of contacts</InputLabel>
              <Select
                multiple
                value={personContact}
                onChange={handleChange}
                input={<OutlinedInput label="List of contacts" />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
              >
                {contacts.map((name) => (
                  <MenuItem key={name.id} value={name.NomPreNom}>
                    <Checkbox checked={personContact.indexOf(name.NomPreNom) > -1} />
                    <ListItemText primary={name.NomPreNom} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button
              onClick={() => {
                fetchCategorys()
                setOpen(false)
              }}
            >
              Annuler
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
